var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// libs
import React, { useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
import { GenericIcon } from '@swiggy-private/dls-web-icons/dist/GenericIconWeb';
import { Svg12 as ChevronDown } from '@swiggy-private/dls-web-icons/dist/web/generic/chevronDown';
import { Button } from '@swiggy-private/dls-web-core/dist/components/Button';
// components
import Menu from '@/components/Menu';
import { Content } from '@/pages/instamart/home/widgets/AccountSwitcher/widgets/Content';
// widgets
import { GenericAvatar } from '@/widgets/GenericAvatar';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
import Routes from '@/constants/Routes';
import { NULL } from '@/constants/Misc';
// includes
import { getPermissionsApi } from '@/includes/api/account/permissions';
import { listAccountsApi } from '@/includes/api/account/list';
// stores
import useAccountStore from '@/stores/account';
import useDashboardStore from '@/stores/Dashboard';
// styles
import styles from './AccountSwitcher.module.scss';
const AccountSwitcher = () => {
    var _a;
    const navigate = useNavigate();
    const menuApiRef = useRef(null);
    const { accounts, loggedInAccountDetails, getCurrentAccountId, setLoggedInAccountDetails, setAccounts, } = useAccountStore();
    const { activeCampaigns } = useDashboardStore();
    const selectedAccountName = ((_a = loggedInAccountDetails.account) === null || _a === void 0 ? void 0 : _a.name) || NULL;
    useEffect(() => {
        !accounts.length && fetchAccounts();
    }, []);
    const fetchAccounts = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const { accounts } = yield listAccountsApi();
            accounts && setAccounts(accounts);
            if (!loggedInAccountDetails.account) {
                const currentAccountId = yield getCurrentAccountId();
                const selectedAccount = accounts.find((account) => account.accountId === currentAccountId);
                if (selectedAccount) {
                    yield fetchPermissionsAndUpdateAccount(selectedAccount);
                }
            }
        }
        catch (err) {
            if (__DEV__) {
                console.log(err);
            }
        }
    });
    const fetchPermissionsAndUpdateAccount = (account) => __awaiter(void 0, void 0, void 0, function* () {
        const { isAdmin, permissions } = yield getPermissionsApi({
            accountId: account.accountId,
        });
        setLoggedInAccountDetails({
            account,
            isAdmin,
            permissions,
        });
    });
    const toggleMenu = () => {
        if (menuApiRef.current) {
            menuApiRef.current.isOpen
                ? menuApiRef.current.close()
                : menuApiRef.current.open();
        }
    };
    const handleAccountSelect = (account) => __awaiter(void 0, void 0, void 0, function* () {
        toggleMenu();
        yield fetchPermissionsAndUpdateAccount(account);
        navigate(Routes.INSTAMART_HOME, { preventScrollReset: true });
    });
    const handleAdminSwitchAccountClick = () => {
        navigate(Routes.ACCOUNT_SELECT, { preventScrollReset: true });
    };
    const renderAccountSwitcher = () => (React.createElement(Menu, { Content: Content, placement: "bottom-start", contentProps: {
            accounts: accounts,
            handleSelect: handleAccountSelect,
            selectedAccountName,
        }, ref: menuApiRef }, renderSelectedAccountDetails()));
    const renderSelectedAccountDetails = () => {
        return (React.createElement("div", { className: styles.currentAccount },
            React.createElement(GenericAvatar, { name: selectedAccountName, className: styles.currentAccountAvatar }),
            React.createElement("div", { className: styles.currentAccountDetails },
                React.createElement("div", { className: styles.currentAccountLineOne, onClick: toggleMenu },
                    React.createElement(Text, { variant: DlsFontVariants.body_B2_Bold, color: DlsColorTokens.text_Highest_Emphasis }, selectedAccountName),
                    accounts.length > 0 && (React.createElement(GenericIcon, { Icon: ChevronDown, fillColor: DlsColorTokens.text_Highest_Emphasis }))),
                React.createElement(Text, { variant: DlsFontVariants.body_B3_Reg, color: DlsColorTokens.text_Low_Emphasis },
                    activeCampaigns.length,
                    " Active Campaigns"))));
    };
    const renderAdminLoginButton = () => (React.createElement("div", { className: styles.adminContainer },
        React.createElement(Button, { variant: "primary", buttonSize: "small", onClick: handleAdminSwitchAccountClick }, "Switch Account")));
    return (React.createElement("div", { className: styles.container },
        accounts.length > 0 && renderAccountSwitcher(),
        loggedInAccountDetails.isAdmin && (React.createElement(React.Fragment, null,
            renderSelectedAccountDetails(),
            renderAdminLoginButton()))));
};
export default AccountSwitcher;
